module.exports = __webpack_public_path__ + "static/media/globe.8b8dbd9b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Contact/components/Main/globe.svg
// module id = 114
// module chunks = 0